<div class="flex items-center gap-sm self-start">
  <select
    sbInput
    class="max-w-fit"
    [ngModel]="selectedYear()"
    (ngModelChange)="selectedYear.set($event)"
    data-testid="year-picker"
    [attr.aria-label]="'Year' | translate"
  >
    @for (yearOption of years(); track yearOption) {
      <option [value]="yearOption">{{ yearOption }}</option>
    }
  </select>

  <select
    sbInput
    class="max-w-fit"
    [ngModel]="selectedView()"
    (ngModelChange)="selectedView.set($event)"
    data-testid="view-picker"
    [attr.aria-label]="'View' | translate"
  >
    @for (viewOption of views; track viewOption.option) {
      <option [value]="viewOption.option">{{ viewOption.label | translate }}</option>
    }
  </select>
</div>
<div class="flex items-start gap-md">
  <sb-card class="min-w-min grow">
    <sb-card-content>
      @if (loadingAbsence()) {
        <sb-loading-state class="py-4xl" />
      } @else {
        <absence-calendar
          [year]="selectedYear()"
          [minYear]="minYear()"
          [maxYear]="maxYear()"
          [pendingAbsences]="absencePending()"
          [reviewedAbsences]="absenceReviewed()"
          (yearChange)="selectedYear.set($event)"
          [view]="selectedView()"
        ></absence-calendar>
      }
      <absence-list-section
        [loadingAbsences]="loadingAbsence()"
        [pendingAbsences]="absencePending()"
        [reviewedAbsences]="absenceReviewed()"
        [employee]="employee()"
        [selectedYear]="selectedYear()"
      ></absence-list-section>
    </sb-card-content>
  </sb-card>
  @if (canViewBalances() || canViewAbsenceTypeDistribution()) {
    <sb-card class="w-64 shrink-0">
      <sb-card-content>
        @if (canViewBalances()) {
          <time-off-balances [year]="selectedYear()" [employee]="employee()"></time-off-balances>
        }
        @if (canViewBalances() && canViewAbsenceTypeDistribution()) {
          <hr sbDivider />
        }
        @if (canViewAbsenceTypeDistribution()) {
          <absence-type-distribution [employeeId]="employee()?.id" [year]="selectedYear()"></absence-type-distribution>
        }
      </sb-card-content>
    </sb-card>
  }
</div>
